/*
 * @Author: DYM
 * @Date: 2021-03-03 15:38:15
 * @LastEditors: DYM
 * @LastEditTime: 2021-03-03 15:38:26
 * @Description: file content
 */
import Vue from 'vue';
import ReProgress from './reProgress.vue';
Vue.component('ReProgress', ReProgress);
